import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function IntroSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="relative py-20 md:py-28 bg-background-100 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-20 left-10 w-64 h-64 bg-accent-50/40 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-8">
        {/* Label */}
        <span className="inline-block text-xs md:text-sm text-accent-500 font-medium tracking-widest uppercase mb-6">
          {t('intro.label')}
        </span>

        {/* Content Grid */}
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Text */}
          <div className="w-full lg:w-2/3">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              {t('intro.text')}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8">
              {t('intro.text2')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => navigate('/media')}
                className="group flex items-center gap-2 px-6 py-3 bg-[#0A2D5E] hover:bg-[#0C3A75] text-background-50 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap"
              >
                {t('intro.cta.media')}
                <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform" />
              </button>
              <button
                onClick={() => navigate('/videos')}
                className="group flex items-center gap-2 px-6 py-3 border border-[#0A2D5E] text-[#0A2D5E] hover:bg-[#0A2D5E] hover:text-background-50 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap"
              >
                {t('intro.cta.videos')}
                <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform" />
              </button>
            </div>
          </div>

          {/* Side Image */}
          <div className="w-full lg:w-1/3">
            <div className="relative rounded-xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20public%20art%20monument%20memorial%20sculpture%20in%20outdoor%20plaza%20sleek%20metal%20design%20sunlight%20blue%20sky%20white%20clouds%20architectural%20photography%20minimal%20composition%20elegant%20contemporary%20art%20landmark%20structure%20clean%20lines%20editorial%20style&width=600&height=450&seq=intro-monument-001&orientation=landscape"
                alt="Peace Monument"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-800/20 to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}